/**
 * here put all the actions from api, using the types
 */
import {
  GET_GENERAL_INFO_INIT,
  GET_GENERAL_INFO_SUCCESS,
  GET_GENERAL_INFO_FAILURE,
  GET_CLIENT_INFO_INIT,
  GET_CLIENT_INFO_SUCCESS,
  GET_CLIENT_INFO_FAILURE,
} from './types';
import API from '../lib/api';

/**
 * Action creators
 * Actions handling the general information of the viz
 */
export const getGeneralInfoInit = () => ({ type: GET_GENERAL_INFO_INIT });

export const getGeneralInfoSuccess = data => ({
  type: GET_GENERAL_INFO_SUCCESS,
  payload: data,
});

export const getGeneralInfoFailure = error => ({
  type: GET_GENERAL_INFO_FAILURE,
  payload: error,
});

/**
 * Actions handling the client information
 */
export const getClientInfoInit = () => ({ type: GET_CLIENT_INFO_INIT });

export const getClientInfoSuccess = data => ({
  type: GET_CLIENT_INFO_SUCCESS,
  payload: data,
});

export const getClientInfoFailure = error => ({
  type: GET_CLIENT_INFO_FAILURE,
  payload: error,
});

/**
 * Action creators ASYNC
 * Action handling async fetch of the general information of the viz
 */
export const getGeneralInfo = () => async (dispatch) => {
  // Initial call, fetching the .json
  dispatch(getGeneralInfoInit());
  try {
    const data = await API.app.getGeneralInfo();
    return dispatch(getGeneralInfoSuccess(data));
  } catch (error) {
    return dispatch(getGeneralInfoFailure(error));
  }
};

/**
 * Action handling async fetch of the client information
 */
export const getClientInfo = () => async (dispatch) => {
  // Initial call, fetching the .json
  dispatch(getClientInfoInit());
  try {
    const data = await API.app.getClienInfo();
    return dispatch(getClientInfoSuccess(data));
  } catch (error) {
    return dispatch(getClientInfoFailure(error));
  }
};
